export const finishTypes = {
  'Polished Chrome': 'chrome',
  'Brushed Nickel': 'nickel',
  'Polished Brass': 'brass',
  'Brushed Stainless': 'stainless',
  Graphite: 'graphite',
  'Matte Black': 'black',
  'Matte White': 'white',
  'Black': 'black',
  '304 Stainless Steel': 'stainless'
};

export function sortFinishes(values) {
  const names = Object.keys(finishTypes);
  return values
    .map((item, i) => {
      const order = names.indexOf(item.name);
      item._order = order !== -1 ? order : i * 10;
      return item;
    })
    .sort((a, b) => (a._order < b._order ? -1 : 1));
}

export const finishTranslations = {
  'brushed-nickel': ['Brushed Nickel', 'Níquel Cepillado', '镀镍拉丝'],
  'brushed-stainless': [
    'Brushed Stainless',
    'Inoxidable Cepillado',
    '不锈钢拉丝'
  ],
  graphite: ['Graphite', 'Grafito', '石墨'],
  'matte-black': ['Matte Black', 'Negro Mate', '哑光黑'],
  'matte-white': ['Matte White', 'Blanco Mate', '哑光白'],
  'polished-brass': ['Polished Brass', 'Latón Pulido', '抛光黄铜'],
  'polished-chrome': ['Polished Chrome', 'Cromo Pulido', '抛光铬'],
  'stainless': ['304 Stainless Steel', '', ''],
  'black': ['Black', '', '']
};

export function getFinishClassName(finish) {
  return Object.keys(finishTranslations).find(key => {
    if (finishTranslations[key].includes(finish)) {
      return key;
    }
  });
}
